import { indexImagesByCode } from "@/helpers/mobImage/indexImagesByCode"

const MOB_CARD_IMAGE_BY_CODE = indexImagesByCode(
  import.meta.glob("/src/assets/images/mobs/card/*.webp", {
    eager: true,
    import: "default"
  }) as Record<string, string>
)

const MOB_ICON_IMAGE_BY_CODE = indexImagesByCode(
  import.meta.glob("/src/assets/images/mobs/icon/*.webp", {
    eager: true,
    import: "default"
  }) as Record<string, string>
)

const resolveFrom = (
  index: Record<string, string>,
  code: string
): string | undefined => (Object.hasOwn(index, code) ? index[code] : undefined)

export const resolveMobCardImage = (code: string): string | undefined =>
  resolveFrom(MOB_CARD_IMAGE_BY_CODE, code)

export const resolveMobIconImage = (code: string): string | undefined =>
  resolveFrom(MOB_ICON_IMAGE_BY_CODE, code)
